import React from "react";
import primaryComponents from "../../../../primaryComponents";
import { useConnectBusiness } from "../ConnectBusiness/useConnectBusiness";
import useValidation from "../ConnectBusiness/useValidation";
import styles from "./styles.module.scss";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { CopyIcon } from "../../../../../assets/svgIcons";
import CopyToClipboard from "react-copy-to-clipboard";
import { truncateString } from "../../../../../helpers";

export const ConnectPublicKeys = ({
  fieldProps = {},
  businessAccountDetails = {},
  ...rest
}) => {
  const allFields = fieldProps?.fieldList;
  const {
    isConnectingBusiness,
    formDetails,
    setFormDetails,
    connectBusiness,
    triggerToast,
  } = useConnectBusiness({
    fieldProps,
    businessAccountDetails,
    ...rest,
  });

  const {
    register,
    control,
    formState: { errors },
    handleSubmit,
    trigger,
  } = useValidation({
    ...formDetails,
    providerFields: allFields?.map((item) => {
      return item?.isRequired ? item?.key : "null";
    }),
  });

  return (
    <div
      className="d-flex flex-column"
      style={{ gap: "50px", maxWidth: "90%" }}
    >
      <div className={`${styles.section} ${styles.largeView}`}>
        <span className={styles.section__number}>
          <span className="success--text">Step 1</span> of 2
        </span>
        <hr className={styles.section__line} />
        <div className={styles.section__content}>
          <h6 className="mb-0">
            Generate your Opay public key & Client auth Key
          </h6>

          <div
            className={`${globalStyles.cardWithBackground} card-plain`}
            style={{ gap: "30px" }}
          >
            <p>How to generate your Public key & Client auth key via Opay</p>

            <div>
              <p>
                <span className="font-weight-semibold dark--text mr-2">1.</span>
                Visit this link:{" "}
                <a
                  className="purple--text"
                  href="https://saas.opayweb.com/developer-tools"
                >
                  https://saas.opayweb.com/developer-tools
                </a>
              </p>
            </div>

            <div>
              <p>
                <span className="font-weight-semibold dark--text mr-2">2.</span>
                Copy the details below and paste into the respective forms on
                the Opay page to generate your public key & client auth key
              </p>

              <div
                className={`${globalStyles.cardWithBackground} ${globalStyles.gridDetailsView} white flex-row mt-2 ml-3`}
                style={{ gap: "20px" }}
              >
                <div>
                  <div className="d-flex align-items-center mb-2">
                    <h6 className="mb-0">Public Key</h6>
                    <CopyToClipboard
                      onCopy={() => triggerToast("Copied", "success")}
                      text={businessAccountDetails?.merchant_public_key}
                    >
                      <primaryComponents.Button
                        classNames={"ml-2 btn btn--outline smallBtn"}
                      >
                        <CopyIcon className="mr-1" color="#7647ee" /> Copy
                      </primaryComponents.Button>
                    </CopyToClipboard>
                  </div>
                  <p style={{ wordWrap: "break-word" }}>
                    {truncateString(
                      businessAccountDetails?.merchant_public_key,
                      50,
                    )}
                  </p>
                </div>
                <div className="w-100">
                  <div className="d-flex align-items-center mb-2">
                    <h6 className="mb-0">Webhook URL</h6>
                    <CopyToClipboard
                      onCopy={() => triggerToast("Copied", "success")}
                      text={businessAccountDetails?.webhook_url}
                    >
                      <primaryComponents.Button
                        classNames={"ml-2 btn btn--outline smallBtn"}
                      >
                        <CopyIcon className="mr-1" color="#7647ee" /> Copy
                      </primaryComponents.Button>
                    </CopyToClipboard>
                  </div>
                  <p style={{ wordWrap: "break-word" }}>
                    {truncateString(businessAccountDetails?.webhook_url, 50)}
                  </p>
                </div>
                <div className="w-100">
                  <div className="d-flex align-items-center mb-2">
                    <h6 className="mb-0">IP Address</h6>
                    <CopyToClipboard
                      onCopy={() => triggerToast("Copied", "success")}
                      text={businessAccountDetails?.ip_address}
                    >
                      <primaryComponents.Button
                        classNames={"ml-2 btn btn--outline smallBtn"}
                      >
                        <CopyIcon className="mr-1" color="#7647ee" /> Copy
                      </primaryComponents.Button>
                    </CopyToClipboard>
                  </div>
                  <p style={{ wordWrap: "break-word" }}>
                    {businessAccountDetails?.ip_address || "N/A"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={`${styles.section} ${styles.largeView}`}>
        <span className={styles.section__number}>
          <span className="success--text">Step 2</span> of 2
        </span>
        <hr className={styles.section__line} />
        <div className={styles.section__content}>
          <h6 className="mb-0">
            Paste your generated Opay public key & client auth key into the
            respective fields below
          </h6>

          <div>
            <form
              id={fieldProps?.name}
              onSubmit={handleSubmit(connectBusiness)}
            >
              <div
                className={`${globalStyles.cardWithBorder} flex-row`}
                style={{ gap: "10px" }}
              >
                {allFields?.map((field, index) => {
                  return (
                    <React.Fragment key={index}>
                      <primaryComponents.InputFieldV2
                        control={control}
                        classNames="white"
                        label={field?.label}
                        placeholder={`Enter ${field?.label}`}
                        name={field?.key}
                        value={formDetails?.[field?.key]}
                        isRequired={field?.isRequired}
                        register={register}
                        errorMessage={errors?.[field?.key]}
                        onKeyUp={() =>
                          errors?.[field?.key] !== undefined &&
                          trigger(field?.key)
                        }
                        onChange={({ target: { value } }) => {
                          setFormDetails((prevState) => ({
                            ...prevState,
                            [field?.key]: value,
                          }));
                        }}
                      />
                    </React.Fragment>
                  );
                })}
              </div>

              <primaryComponents.Button
                classNames={"ml-auto btn btn--primary mt-4"}
                style={{ width: "200px" }}
                type="submit"
                isDisabled={isConnectingBusiness}
                isLoading={isConnectingBusiness}
                loadingText={"Connecting..."}
              >
                Proceed
              </primaryComponents.Button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
